export default __webpack_public_path__ + "static/media/cdc-falconeres.169edff8.jpg";